import clsx from 'clsx'
import React from 'react'
import type SvgIcon from '../SvgIcon/SvgIcon'
import type { UtilityColor } from '../utilities/colors'

export interface TagProps {
  color?: TagColor
  label: string
  size?: TagSize
  startAdornment?: typeof SvgIcon
}

type TagSize = 'large' | 'medium' | 'small'
type TagSizes = {
  [key in TagSize]: {
    root: string
    icon: string
    text: string
  }
}
type TagColor = UtilityColor | 'grey'
type TagColors = { [key in TagColor]: string }

const sizes: TagSizes = {
  large: {
    icon: 'w-5 mr-1',
    root: 'p-1',
    text: 'font-sans text-sm font-normal leading-4',
  },
  medium: {
    icon: 'w-4 mr-1',
    root: 'p-1',
    text: 'font-sans text-xs font-normal leading-3',
  },
  small: {
    icon: 'w-3 mr-0.5',
    root: 'p-0.75',
    text: 'font-sans text-xs font-normal leading-3',
  },
}

export const colors: TagColors = {
  blue: 'border border-blue-600 border-opacity-25 bg-blue-100 text-blue-800',
  default: `border border-black-10 bg-black-5 text-gray-800`,
  grey: `border border-gray-900 border-opacity-25 bg-gray-300 text-gray-800`,
  indigo:
    'border border-indigo-600 border-opacity-25 bg-indigo-100 text-indigo-800',
  pink: 'border border-pink-500 border-opacity-25 bg-pink-100 text-pink-700',
  purple:
    'border border-purple-600 border-opacity-25 bg-purple-100 text-purple-700',
  red: 'border border-red-600 border-opacity-25 bg-red-100 text-red-700',
  teal: 'border border-teal-500 border-opacity-25 bg-teal-100 text-teal-700',
  yellow:
    'border border-yellow-600 border-opacity-25 bg-yellow-100 text-yellow-800',
}

function Tag({
  color = 'default',
  label,
  size = 'medium',
  startAdornment: StartAdornment,
}: TagProps): JSX.Element {
  return (
    <span
      className={clsx(
        'rounded-sm inline-flex cursor-default',
        colors[color],
        sizes[size].root,
      )}
    >
      <span className="flex items-center">
        {StartAdornment ? (
          <span className={clsx(sizes[size].icon)}>
            <StartAdornment />
          </span>
        ) : null}
        <span className={clsx('w-full', sizes[size].text)}>{label}</span>
      </span>
    </span>
  )
}
export default Tag
